<template>
  <v-container class="custom-container custom-responsive-height">
    <v-row dense>
      <v-col cols="12">
        <v-card class="pa-5" elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
          <v-row dense>
            <v-col cols="12" sm="12" md="10" lg="11" :md="$canRoute('user-activity') !== 1 ? 12 : 10" :lg="$canRoute('user-activity') !== 1 ? 12 : 11">
              <v-text-field v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify" label="Search here..."
                single-line solo hide-details class="custom-v-input">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="2" lg="1" v-if="$canRoute('user-activity') === 1">
              <v-btn @click.prevent="downloadCSV" tile elevation="0" to="" class="text-capitalize btn-account mb-0 mx-0"
                color="greenMain">
                <v-icon small>mdi mdi-tray-arrow-down</v-icon>CSV
              </v-btn>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
                <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
                  <v-data-table :headers="headers" :items="users" :server-items-length="pagination?.total || 10"
                    :options.sync="options" :loading="isLoading" :items-per-page="options.itemsPerPage" :footer-props="{
                      'items-per-page-options': [10, 25, 50, 100],
                      'items-per-page-text': 'Rows per page:'
                    }" @update:options="handleOptionsChange" disable-sort>
                    <template v-slot:loading>
                      <div class="d-flex align-center justify-center pa-4">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        <span class="ml-2">Loading data...</span>
                      </div>
                    </template>
                    <template v-slot:no-data>
                      <div class="d-flex align-center justify-center pa-4">
                        <v-icon color="secondary">mdi-information</v-icon>
                        <span class="ml-2">No data found</span>
                      </div>
                    </template>
                    <template v-slot:no-results>
                      <div class="d-flex align-center justify-center pa-4">
                        <v-icon color="secondary">mdi-magnify</v-icon>
                        <span class="ml-2">No matching data found</span>
                      </div>
                    </template>
                    <template v-slot:item.sl="{ item, index }">
                      {{ index + 1 }}
                    </template>
                    <template v-slot:item.email="{ item }">
                      <v-tooltip top color="#000">
                        <template v-slot:activator="{ on }">
                          <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                            {{ obfuscateAnyEmail(item?.email) }}
                            <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">
                              {{
                                copiedStates[item.id]
                                  ? "mdi mdi-check"
                                  : "mdi-content-copy"
                              }}
                            </v-icon>
                          </v-btn>
                        </template>
                      </v-tooltip>
                       <span v-if="!item.email">N/A</span>
                    </template>
              
                    <template v-slot:item.created_at="{ item }">
                      {{ formatMySQLDate(item?.created_at) }}
                    </template>
                    <template v-slot:item.country_name="{ item }">
                      {{ item.country_name || "N/A" }}
                    </template>
                    <template v-slot:item.fname="{ item }">
                      <router-link class="text-capitalize text--ash" :to="`/registered-user-details/${item?.user_id}`">
                         {{ (item?.fname || "N/A") + " " + (item?.lname || "N/A") }} {{ "(" + item?.user_id || "N/A" + ")" }}
                      </router-link>
                    </template>
                    <template v-slot:item.inactivity_time="{ item }">
                      <span :class="{
                        'text--green': item.inactivity_time === 'Active',
                      }">
                        {{ item.inactivity_time }}
                      </span>
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { USERLOGINACTIVITY__ACTIONS } from "@/store/action-types";
import * as XLSX from "xlsx";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import { formatMySQLDate } from "@/_helpers/formateDate";

export default {
  data() {
    return {
      search: "",
      searchTimeout: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      isCopied: false,
      copiedStates: {},
      headers: [
        { text: "Registered At", align: "start", value: "created_at" },
        { text: "Name", value: "fname" },
        { text: "Email", value: "email" },
        { text: "Country", value: "country_name" },
        { text: "Activity", value: "inactivity_time" },
      ],
    };
  },
  computed: {
    ...mapState("loginactivities", ["users", "pagination", "isLoading"]),
  },
  methods: {
    formatMySQLDate,
    ...mapActions("loginactivities", [
      USERLOGINACTIVITY__ACTIONS.USERLOGINACTIVITY,
    ]),

    copyText(item) {
      navigator.clipboard.writeText(item.email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item.id, false);
      }, 1000);
    },

    obfuscateAnyEmail(email) {
      return obfuscateEmail(email)
    },

    downloadCSV() {
      const wb = XLSX.utils.book_new();
      const apiData = this.users;

      const modifiedData = apiData.map((item) => ({
        NAME: item.fname + " " + item.lname,
        EMAIL: item.email,
        COUNTRY: item.country_name || "N/A",
        ACTIVITY: item.inactivity_time,
      }));

      const ws = XLSX.utils.json_to_sheet(modifiedData);
      XLSX.utils.book_append_sheet(wb, ws, "User Activities");
      const totalRow = modifiedData.length + 2;

      ws["!ref"] = XLSX.utils.encode_range({
        s: { c: 0, r: 0 },
        e: { c: 9, r: totalRow },
      });

      XLSX.writeFile(wb, "user_activities.xlsx");
    },

    async fetchData() {
      const params = {
        page: this.options.page || 1,
        limit: this.options.itemsPerPage || 10,
        search: this.search,
      };

      await this[USERLOGINACTIVITY__ACTIONS.USERLOGINACTIVITY](params);
    },


    async handleSearch() {
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    handleOptionsChange(options) {
      this.fetchData();
    },
  },

  async created() {
    await this.fetchData();
  },
};
</script>
